const TIPOS_CON_SALDO = new Set(['giftcard', 'prepagado']);

export const getModoUso = (giftcard = {}) => (
  TIPOS_CON_SALDO.has(giftcard.tipo) && giftcard.modoUso === 'monto'
    ? 'monto'
    : 'servicio'
);

export const permiteUsoPorMonto = (tipo) => TIPOS_CON_SALDO.has(tipo);
